import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';

declare var _: any;

@Component({
  selector: 'app-monitors-import',
  templateUrl: './monitors-import.component.html',
  styleUrls: ['./monitors-import.component.scss']
})
export class MonitorsImportComponent implements OnInit {

  users : any;
  search = "";

  constructor(private router: Router, private route: ActivatedRoute, public okService:OkAloneService) { }


  ngOnInit(): void {

    this.getUsers();

  }
  getUsers(){

    this.okService.get("geotab/users",{})
    .subscribe((data) => {

      this.users = data.body;


    });

  }
  
  importMonitor(user:any){
    //console.log(user);        
    
    this.okService.post("monitors",user)
    .subscribe((data) => {

      //console.log(data);

      user.is_monitor = true;

      this.okService.setAlert("The monitor "+user.name+" has been added","success");

    });
  }

  doSearch(){
    //console.log(this.search);

    let search = this.search;

    this.okService.get("geotab/users",{search:search})
    .subscribe((data) => {

      //console.log(data);

      this.users = data.body;


    });


  }
  cancelSearch(){
    //console.log(this.search);

    this.search="";

    this.getUsers();

  }
}
